<template>
  <v-container id="page-driver-list">
    <div class="page-title">{{$route.name}}</div>

    <v-row>
      <v-col>
        <v-row class="pl-2">
          <v-menu
            v-model="startMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <div style="width: 200px">
                <v-text-field
                  v-model="startDate"
                  label="시작일"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </div>
            </template>
            <c-date-picker v-model="startDate" @input="startMenu = false" firstDayOfWeek="1" :selectedDate="startDate" locale="ko-kr"></c-date-picker>
          </v-menu>
          <v-menu
              v-model="endMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <div class="ml-5" style="width: 200px">
                <v-text-field
                  v-model="endDate"
                  label="종료일"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </div>
            </template>
            <c-date-picker v-model="endDate" @input="endMenu = false" firstDayOfWeek="1" :selectedDate="endDate" locale="ko-kr"></c-date-picker>
          </v-menu>
          <v-menu
            v-model="keywordMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <div style="width: 400px">
                <v-text-field
                    v-model="keyword"
                    label="검색어"
                    placeholder="습득 차량, 습득 기사, 분실물 요약"
                    prepend-icon="search"
                    v-on="on"
                    maxlength="32"
                ></v-text-field>
              </div>
            </template>
          </v-menu>
        </v-row>
      </v-col>
      <v-col class="d-flex justify-end">
        <c-btn color="blue" outlined iconName="add" @click="onOpenDialog">분실물등록</c-btn>
        <c-btn class="ml-1" color="blue" outlined iconName="delete" @click="onDeleteLostItems" >분실물삭제</c-btn>
      </v-col>
    </v-row>
    <c-table
      :headers="lostTableHeaders"
      itemKey="id"
      :items="tableData"
      :selected.sync="selectedLostItemList"
      show-select
    >
      <template #type="{ item }">
        {{ item.type? item.type.configName: ''}}
      </template>

      <template #driver="{ item }">
        {{ item.driver? item.driver.name: ''}}
      </template>

      <template #summary="{ item }">
        {{ item.summary && item.summary.length>0? item.summary: '-'}}
      </template>

      <template #state="{ item }">
        {{ item.state? item.state.configName: ''}}
      </template>

      <template #created="{ item }">
          {{item.created? $func.dateToString(item.created): ''}}
      </template>

      <template #detail="{ item }">
        <c-btn icon iconName="search" @click="onMoveDetail(item.id)"/>
      </template>

    </c-table>

    <lost-item-c-u-dialog
      :open.sync="addLostItemDialog"
      :driverList="driverList"
      @reqAddLostItem="reqAddLostItem"
    />
  </v-container>

</template>
<script>
  import LostItemCUDialog from "./LostItemCUDialog";

  export default {
    components: {
      LostItemCUDialog,
    },
    data() {
      return {
        lostTableHeaders: [
          {
            text: '물품 분류',
            value: 'type',
            align: 'center',
            sortable: true,
          },
          {
            text: '습득 차량',
            value: 'vehicle',
            align: 'center',
            sortable: false,
          },
          {
            text: '습득 기사',
            value: 'driver',
            align: 'center',
            sortable: true,
          },
          {
            text: '습득일',
            value: 'getDate',
            align: 'center',
            sortable: true,
          },
          {
            text: '분실물 요약',
            value: 'summary',
            align: 'center',
            sortable: false,
          },
          {
            text: '분실물 상태',
            value: 'state',
            align: 'center',
            sortable: true,
          },
          {
            text: '등록일',
            value: 'created',
            align: 'center',
            sortable: true,
          },
          {
            text: '상세보기',
            value: 'detail',
            align: 'center',
            sortable: false,
          },
        ],
        lostItemList: [],
        addLostItemDialog: false,

        keyword: '',
        keywordMenu: false,
        tableData: [],

        driverList: [], //분실물 등록 시 담당 기사 목록

        selectedLostItemList: [],

        endMenu: false,
        startMenu: false,
        startDate: this.$moment().subtract(7,'days').format('YYYY-MM-DD'),
        endDate: this.$func.dateToString(),
      }
    },
    activated() {
      this.reqGetLostItemList();
    },
    watch: {
      startDate: function () {
        this.reqGetLostItemList();
      },
      endDate: function () {
        this.reqGetLostItemList();
      },
      keyword: function () {
        this.filterTableData();
      },
    },
    methods: {
      async onOpenDialog() {
        await this.reqGetDriverList();
        this.addLostItemDialog = true;
      },
      onMoveDetail(id) {
        this.$router.push(`/lostItem/${id}`);
      },
      onDeleteLostItems() {
        if(this.selectedLostItemList.length < 1)
          this.$store.commit('snackbar', {msg: '선택된 항목이 없습니다.'});
        else
          this.$store.commit('alert', {
            open: true, msg: '분실물을 삭제하시겠습니까?',
            confirm: true, persistent: true,
            callBack: () => {
              this.reqDeleteLostItems();
            }
          });
      },
      async reqGetLostItemList() {
        try {
          const res = await this.$api.getLostItemListByRange(this.startDate, this.endDate);
          this.lostItemList = res.data;
          this.filterTableData();
        } catch(err) {
          this.$store.commit('snackbar', {err, where:'reqGetLostItemList'});
        }
      },
      async reqGetDriverList() {
        try {
          const res = await this.$api.getDriverList();
          if(res && res.data)
            this.driverList = res.data.map(item => item.driver);

        } catch(err) {
          this.$store.commit('snackbar', {err, where:'reqGetDriverList'});
        }
      },
      async reqAddLostItem(data) {
        try {
          const res = await this.$api.addLostItem(data);
          this.addLostItemDialog = false;
          this.reqGetLostItemList();
          this.$store.commit('snackbar', {color: 'blue', msg: '등록이 완료 되었습니다.'});

        } catch (err) {
          this.$store.commit('snackbar', {err, where:'reqAddLostItem'});
        }
      },
      async reqDeleteLostItems() {
        try {
          await this.$api.deleteLostItems(this.selectedLostItemList.map(item => item.id));
          this.selectedLostItemList = [];
          this.reqGetLostItemList();
          this.$store.commit('snackbar', {color: 'blue', msg: '삭제가 완료 되었습니다.'});

        } catch(err) {
          this.$store.commit('snackbar', {err, where:'reqDeleteLostItems'});
        }
      },
      filterTableData() {
        this.tableData = [];
        this.lostItemList.map((item, idx) => {
          if (item.vehicle.indexOf(this.keyword) > -1 || item.driver.name.indexOf(this.keyword) > -1 || item.summary.indexOf(this.keyword) > -1) {
            this.tableData.push(item);
          }
        });
      },
    },
  }
</script>

<style>

</style>